import { ArrowLeft } from 'lucide-react'
import Link from 'next/link'
import { useRouter } from 'next/router'

import { type NonFsdsPuckPageProps,createNonFsdsPageGetServerSideProps } from '@/lib/create-non-fsds-page-gssp'
import { useBranding } from '@/hooks/use-branding'

import NonFsdsForgotPasswordPage from '@/components/auth/non-fsds-forgot-password-page'
import { ForgotPasswordForm } from '@/components/forms/auth/forgot-password-form'
import NonFsdsEditablePageShell from '@/components/puck/non-fsds-editable-page-shell'
import SEO from '@/components/seo/SEO'
import { Card } from '@/components/ui/card'

export const getServerSideProps = createNonFsdsPageGetServerSideProps('forgot-password')

export default function ForgotPasswordPage({ puckData }: NonFsdsPuckPageProps) {
  const { isFsdsDomain } = useBranding()
  const isNonFsds = !isFsdsDomain
  const router = useRouter()
  const emailFromQuery =
    typeof router.query.email === 'string' ? router.query.email : undefined

  if (isNonFsds) {
    return (
      <NonFsdsEditablePageShell
        slug="forgot-password"
        seoTitle="Forgot Password"
        puckData={puckData}
        fallback={<NonFsdsForgotPasswordPage />}
      />
    )
  }

  return (
    <>
      <SEO title="Forgot Password" />
      <div className="container grid h-svh flex-col items-center justify-center bg-background lg:max-w-none lg:px-0">
        <div className="mx-auto flex w-full flex-col justify-center space-y-2 sm:w-[480px] lg:p-8">
          <div className="mb-4 flex flex-col items-center justify-center space-y-4">
            <h1 className="text-3xl font-medium">Forgot Password ?</h1>
            <p className="text-sm text-muted-foreground">
              No worries, we&apos;ll send you reset instructions.
            </p>
          </div>
          <Card className="p-6">
            <div className="mb-2 flex flex-col space-y-2 text-left"></div>
            <ForgotPasswordForm defaultEmail={emailFromQuery} />
          </Card>
          <div className="flex w-full">
            <p className="mx-auto mt-6 flex space-x-3 px-8">
              <Link
                href="/sign-in"
                className="flex items-center text-sm font-medium text-muted-foreground hover:text-primary"
              >
                <ArrowLeft className="mr-2 h-4 w-4" />
                Back to sign in
              </Link>
            </p>
          </div>
        </div>
      </div>
    </>
  )
}
